<template>
  <span>
    <span v-if="reply">
      [
      <span v-if="isOwner"> Sent by <strong>You</strong> </span>
      <span v-else-if="item.SentByCreator">
        Sent by <strong>{{ item.UserFullName }}</strong>
      </span>
      <span v-else>
        Sent by <strong>{{ item.CreatorUserFullName }}</strong>
      </span>
      on {{ getTimeAgo(item.CreationDate) }}]</span
    >
    <span v-else-if="item">
      [
      <span v-if="isOwner && item.UserFullName">
        Sent to <strong>{{ item.UserFullName }}</strong>
      </span>
      <span v-else-if="item.CreatorUserFullName">
        Sent by <strong>{{ item.CreatorUserFullName }}</strong>
      </span>
      on {{ getTimeAgo(item.CreationDate) }}]</span
    >
  </span>
</template>
<script lang="ts">
import Utils from "../../utils/Utils";
import { defineComponent } from "vue";
import { NotificationType } from "../../definitions/constants";

export default defineComponent({
  components: {},
  props: ["item", "reply", "isOwner"],
  data() {
    return {
      notificationTypes: NotificationType,
    };
  },
  methods: {
    getTimeAgo(date: Date) {
      return Utils.toVsDateFormat(date);
    },
  },
});
</script>
